function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "base"
}, /*#__PURE__*/React.createElement("rect", {
  width: 122,
  height: 191
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "two"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28,15.1v-2.5c0-3.4-2.8-6.2-6.2-6.2h-5.1c-3.4,0-6.2,2.8-6.2,6.2v4.1h5.2v-3c0-1.9,1.5-3.4,3.4-3.4h0 c1.9,0,3.4,1.5,3.4,3.4c0,0,0-1.9,0,1.4c0,4.9-12.1,11.1-12.1,17.1v4.4H28v-4.4H15.9C15.9,26.3,28,22.4,28,15.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94,175.9v2.5c0,3.4,2.8,6.2,6.2,6.2h5.1c3.4,0,6.2-2.8,6.2-6.2v-4.1h-5.2v3c0,1.9-1.5,3.4-3.4,3.4h0 c-1.9,0-3.4-1.5-3.4-3.4c0,0,0,1.9,0-1.4c0-4.9,12.1-11.1,12.1-17.1v-4.4H94v4.4h12.1C106.1,164.7,94,168.6,94,175.9z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "three_1_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2,22.6c1.9,0,3.4,1.5,3.4,3.4v2.9c0,1.9-1.5,3.4-3.4,3.4h0c-1.9,0-3.4-1.5-3.4-3.4v-2h-5.2V30c0,3.4,2.8,6.2,6.2,6.2 h5.1c3.4,0,6.2-2.8,6.2-6.2V26c0-2.4-1.3-4.4-3.3-5.5c2-1,3.3-3.1,3.3-5.5v-2.5c0-3.4-2.8-6.2-6.2-6.2h-5.1c-3.4,0-6.2,2.8-6.2,6.2 V15h5.2v-1.4c0-1.9,1.5-3.4,3.4-3.4h0c1.9,0,3.4,1.5,3.4,3.4v1.8c0,1.9-1.5,3.4-3.4,3.4h-2.9v3.7H19.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.6,172.2c-1.9,0-3.4,1.5-3.4,3.4v1.8c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V176h5.2v2.4 c0,3.4-2.8,6.2-6.2,6.2H100c-3.4,0-6.2-2.8-6.2-6.2v-2.5c0-2.4,1.3-4.4,3.3-5.5c-2-1-3.3-3.1-3.3-5.5V161c0-3.4,2.8-6.2,6.2-6.2 h5.1c3.4,0,6.2,2.8,6.2,6.2v3.1H106v-2c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v2.9c0,1.9,1.5,3.4,3.4,3.4h1.9v3.7H102.6z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "four"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.5,27V6.6h-5.9L9.4,27v4.2h11.3v5.4h5.9v-5.4h2.5V27H26.5z M20.6,27h-6.2l6.2-12.1V27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.5,164v20.4h5.9l11.3-20.4v-4.2h-11.3v-5.4h-5.9v5.4h-2.5v4.2H95.5z M101.4,164h6.2l-6.2,12.1V164z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "five"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7,23.7h-5.2l0.9-17.2h15.7v3.8H16.8l-0.5,7.7c1.4-1.8,3.1-2.2,4.3-2.3h1.8c3.9,0,5.6,3.4,5.6,7.4V30 c0,3.4-2.8,6.2-6.2,6.2h-5.1c-3.4,0-6.2-2.8-6.2-6.2v-3h5.2v1.9c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V23 c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4V23.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.3,167.3h5.2l-0.9,17.2H94.9v-3.8h10.3l0.5-7.7c-1.4,1.8-3.1,2.2-4.3,2.3h-1.8c-3.9,0-5.6-3.4-5.6-7.4V161 c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v3h-5.2v-1.9c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v5.9 c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V167.3z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "six"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7,28.9c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V24c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4V28.9z  M10.5,12.6c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v1.5h-5.4v-0.4c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v6 l0.5-0.7c1.4-1.8,3.1-2.2,4.3-2.3h1.8c3.9,0,5.6,3.4,5.6,7.4V30c0,3.4-2.8,6.2-6.2,6.2h-5.1c-3.4,0-6.2-2.8-6.2-6.2v-3V12.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.3,162.1c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v4.9c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V162.1z  M111.5,178.4c0,3.4-2.8,6.2-6.2,6.2h-5.1c-3.4,0-6.2-2.8-6.2-6.2v-1.5h5.4v0.4c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4v-6 l-0.5,0.7c-1.4,1.8-3.1,2.2-4.3,2.3h-1.8c-3.9,0-5.6-3.4-5.6-7.4V161c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v3V178.4z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "nine"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.7,13.7c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v4.9c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4V13.7z  M28,30c0,3.4-2.8,6.2-6.2,6.2h-5.1c-3.4,0-6.2-2.8-6.2-6.2v-1.5h5.4v0.4c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4v-6 l-0.5,0.7c-1.4,1.8-3.1,2.2-4.3,2.3h-1.8c-3.9,0-5.6-3.4-5.6-7.4v-5.9c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v3V30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.3,177.3c0,1.9,1.5,3.4,3.4,3.4h0c1.9,0,3.4-1.5,3.4-3.4v-4.9c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4V177.3z  M94,161c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v1.5h-5.4v-0.4c0-1.9-1.5-3.4-3.4-3.4h0c-1.9,0-3.4,1.5-3.4,3.4v6 l0.5-0.7c1.4-1.8,3.1-2.2,4.3-2.3h1.8c3.9,0,5.6,3.4,5.6,7.4v5.9c0,3.4-2.8,6.2-6.2,6.2h-5.1c-3.4,0-6.2-2.8-6.2-6.2v-3V161z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "seven_1_"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "10.8,6.4 27.6,6.4 27.6,10.8 19.5,36.5 13.7,36.5 22.4,10.1 10.8,10.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "111.2,184.6 94.4,184.6 94.4,180.2 102.5,154.5 108.3,154.5 99.6,180.9 111.2,180.8  "
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "eight_1_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28,15.1v-2.5c0-3.4-2.8-6.2-6.2-6.2h-5.1c-3.4,0-6.2,2.8-6.2,6.2v2.5c0,2.4,1.3,4.4,3.3,5.5c-2,1-3.3,3.1-3.3,5.5V30 c0,3.4,2.8,6.2,6.2,6.2h5.1c3.4,0,6.2-2.8,6.2-6.2V26c0-2.4-1.3-4.4-3.3-5.5C26.6,19.5,28,17.5,28,15.1z M15.7,13.6 c0-1.9,1.5-3.4,3.4-3.4h0c1.9,0,3.4,1.5,3.4,3.4v1.8c0,1.9-1.5,3.4-3.4,3.4h0c-1.9,0-3.4-1.5-3.4-3.4V13.6z M22.6,28.9 c0,1.9-1.5,3.4-3.4,3.4h0c-1.9,0-3.4-1.5-3.4-3.4V26c0-1.9,1.5-3.4,3.4-3.4h0c1.9,0,3.4,1.5,3.4,3.4V28.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.8,175.9v2.5c0,3.4,2.8,6.2,6.2,6.2h5.1c3.4,0,6.2-2.8,6.2-6.2v-2.5c0-2.4-1.3-4.4-3.3-5.5c2-1,3.3-3.1,3.3-5.5V161 c0-3.4-2.8-6.2-6.2-6.2H100c-3.4,0-6.2,2.8-6.2,6.2v3.9c0,2.4,1.3,4.4,3.3,5.5C95.1,171.5,93.8,173.5,93.8,175.9z M106,177.4 c0,1.9-1.5,3.4-3.4,3.4h0c-1.9,0-3.4-1.5-3.4-3.4v-1.8c0-1.9,1.5-3.4,3.4-3.4h0c1.9,0,3.4,1.5,3.4,3.4V177.4z M99.1,162.1 c0-1.9,1.5-3.4,3.4-3.4h0c1.9,0,3.4,1.5,3.4,3.4v2.9c0,1.9-1.5,3.4-3.4,3.4h0c-1.9,0-3.4-1.5-3.4-3.4V162.1z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "ten_1_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.4,6.3h-4.1c-2.7,0-4.9,2.8-4.9,6.3v17.6c0,3.5,2.2,6.3,4.9,6.3h4.1c2.7,0,4.9-2.8,4.9-6.3V12.6 C32.4,9.1,30.2,6.3,27.4,6.3z M27.6,31.2c0,0.9-1,1.7-2.2,1.7s-2.2-0.7-2.2-1.7V11.6c0-0.9,1-1.7,2.2-1.7s2.2,0.7,2.2,1.7V31.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1,36.4h5.1V6.3h-3.6c-1.2,3-3.3,4.2-6.5,4v3.2h5.1V36.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.6,184.7h4.1c2.7,0,4.9-2.8,4.9-6.3v-17.6c0-3.5-2.2-6.3-4.9-6.3h-4.1c-2.7,0-4.9,2.8-4.9,6.3v17.6 C89.6,181.9,91.8,184.7,94.6,184.7z M94.4,159.8c0-0.9,1-1.7,2.2-1.7s2.2,0.7,2.2,1.7v19.6c0,0.9-1,1.7-2.2,1.7s-2.2-0.7-2.2-1.7 V159.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.9,154.6h-5.1v30.1h3.6c1.2-3,3.3-4.2,6.5-4v-3.2h-5.1V154.6z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "jack"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8,36.5L17.8,36.5c2.9,0,5.3-2.4,5.3-5.3V6.3h-5.3v23.3c0,1.5-1.2,2.6-2.6,2.6h0h-2.8v4.2H17.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.7,154.5L103.7,154.5c-2.9,0-5.3,2.4-5.3,5.3v24.9h5.3v-23.3c0-1.5,1.2-2.6,2.6-2.6h0h2.8v-4.2H103.7"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "queen"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.8,33.6c0.8-0.8,1.3-1.8,1.3-2.8V11.5C28,8.5,24,6,18.9,6s-9.1,2.5-9.1,5.5v19.2c0,3,4.1,5.5,9.1,5.5 c1.5,0,2.9-0.2,4.2-0.6c1.8,2.6,6,1.9,6,1.9v-3.6C28.1,34.1,27.4,33.9,26.8,33.6z M22.2,29.9c0,1.4-1.5,2.5-3.3,2.5 c-1.8,0-3.3-1.1-3.3-2.5V12.7c0-1.4,1.5-2.5,3.3-2.5c1.8,0,3.3,1.1,3.3,2.5V29.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3,157.4c-0.8,0.8-1.3,1.8-1.3,2.8v19.2c0,3,4.1,5.5,9.1,5.5s9.1-2.5,9.1-5.5v-19.2c0-3-4.1-5.5-9.1-5.5 c-1.5,0-2.9,0.2-4.2,0.6c-1.8-2.6-6-1.9-6-1.9v3.6C93.9,156.9,94.7,157.1,95.3,157.4z M99.8,161.1c0-1.4,1.5-2.5,3.3-2.5 c1.8,0,3.3,1.1,3.3,2.5v17.2c0,1.4-1.5,2.5-3.3,2.5c-1.8,0-3.3-1.1-3.3-2.5V161.1z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "king"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "10.4,6.6 15.7,6.6 15.7,19.9 23.9,6.6 29.7,6.6 21.4,19.9 29.7,36.7 23.9,36.7 18,24.2 15.9,27.6 15.9,36.7  10.4,36.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "111.6,184.4 106.3,184.4 106.3,171.1 98.1,184.4 92.3,184.4 100.6,171.1 92.3,154.3 98.1,154.3 104,166.8  106.1,163.4 106.1,154.3 111.6,154.3  "
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "ace_1_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.3,6.6h-8.5L8.9,36.5h5.2l1.1-5.9h7.4l1.2,5.9h5.5L23.3,6.6z M16,26.7l2.8-15.3l3.1,15.3H16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.4,184.4h8.5l5.9-29.9h-5.2l-1.1,5.9h-7.4l-1.2-5.9h-5.5L98.4,184.4z M105.7,164.3l-2.8,15.3l-3.1-15.3H105.7z"
}));

var SvgRanks = function SvgRanks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 122 191",
    style: {
      enableBackground: "new 0 0 122 191"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRanks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ranks.1d322c14.svg";
export { ForwardRef as ReactComponent };